/* BUTTON IN THE NAVIGATIONO BAR */
import React from 'react';
import './App.css';
import IconButton from '@material-ui/core/IconButton';

import SpText from './SpText';
import { styled } from '../styled';
import { theme } from '../theme';

const variants = {
  headerButton: {
    border: '2px solid transparent',
    color: theme.colors.mainGreen.main,
    '&:hover': {
      background: 'transparent !important'
    },
    '&:disabled': {
      color: theme.colors.mainGreen.secondary,
      background: 'transparent !important',
      opacity: 0.23
    }
  },
  actionButton: {
    border: '2px solid ' + theme.colors.mainGreen.main,
    borderRadius: '20px',
    color: theme.colors.mainGreen.main,
    '&:hover': {
      background: 'transparent !important'
    },
    '&:disabled': {
      color: theme.colors.mainGreen.secondary,
      background: 'transparent !important',
      opacity: 0.23
    }
  }
};

const CustomIconButton = styled(IconButton)(({ variant = 'yellow', small = false }) => ({
  borderRadius: 0,
  height: small ? 30 : 40,
  maxHeight: 30,
  marginTop: 4,
  marginBottom: 4,
  flex: 1,
  padding: 12,
  cursor: 'pointer',
  justifyContent: 'space-between',
  alignItems: 'center',
  ...variants[variant]
}));

const SpIconAndTextButton = React.forwardRef(({ text, style, textVariant, isIconLeft = isIconLeft ? isIconLeft : false, isIconRight = isIconRight ? isIconRight : false, isUpperCase = false, isIconButton = false, children, ...rest }, ref) => (
  <CustomIconButton
    ref={ref}
    {...rest}
    style={{ ...style }}
    disableRipple
    disableFocusRipple
  >
    {isIconLeft && children}
    {text && (
      <SpText
        variant={textVariant}
        isIconButton={isIconButton}
        style={{
          flex: 2,
          textTransform: isUpperCase ? 'uppercase' : 'none',
          fontWeight: textVariant === 'sidebarItem' ? 'normal' : 'bold'
        }}
      >
        {text}
      </SpText>
    )}
    {isIconRight && children}
  </CustomIconButton>
));

export default SpIconAndTextButton;
